/* eslint-disable react/destructuring-assignment,react/no-will-update-set-state */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Select from 'react-select';
import moment from 'moment';
import 'moment/locale/tr';
import { withNamespaces } from 'react-i18next';
import DomesticArea from '../../../components/domestic/area/index';
import AbroadArea from '../../../components/abroad/area/index';
import * as requestActionCreators from '../../../redux/modules/request';
import * as travelExpenseActionsCreators from '../../../redux/modules/travelExpense';
import {trTravelReasons , enTravelReasons} from '../../../mock/travel-reasons';
import { ABROAD, DOMESTIC } from '../../../constants/variables';
import requestValidate from '../../../helpers/RequestValidator';
import getCurrencySymbol from '../../../constants/currencies';
import i18n from "i18next";

import * as Alert from '../../../helpers/Alert';

class EditRequest extends React.Component {
  constructor(props) {
    super(props);

    this.changeRequest = this.changeRequest.bind(this);
    this.changeType = this.changeType.bind(this);
    this.hoursFormat = this.hoursFormat.bind(this);
    this.changeTravelStartDate = this.changeTravelStartDate.bind(this);
    this.changeTravelStartHour = this.changeTravelStartHour.bind(this);
    this.changeTravelEndDate = this.changeTravelEndDate.bind(this);
    this.changeTravelEndHour = this.changeTravelEndHour.bind(this);
    this.changeDescription = this.changeDescription.bind(this);
    this.changeTravelReasons = this.changeTravelReasons.bind(this);
    this.changeIndividualAccommodation = this.changeIndividualAccommodation.bind(this);
    this.changeIndividualAccommodationDays = this.changeIndividualAccommodationDays.bind(this);
    this.repeatSendToManagersApproval = this.repeatSendToManagersApproval.bind(this);

    this.state = {
      checkDayCount: false,
      request: {
        name: 'Talep',
        validation: { isValid: true, message: null },
        type: DOMESTIC,
        travelStartDate: null,
        travelStartHour: null,
        travelEndDate: null,
        travelEndHour: null,
        travelReasons: [],
        description: '',
        domestic: {
          provinces: [],
        },
        abroad: {
          region: null,
          country: null,
          visa: null,
          passportNo: '',
          roadFriends: null,
          workStartDate: null,
          workStartHour: null,
        },
        individualAccommodation: false,
        individualAccommodationDays: 0,
        calculatedAmount: {},
        harcirahIleriyeDonukKontrolVarMi: false,
      },
      requestType: '',
    };
  }

  async componentWillMount() {
    const {
      match, history, request, getRequest,i18n
    } = this.props;
    moment.locale(i18n.language === 'en' ? 'en' : 'tr');
    if (!match.params.id) {
      history.push('/');
    }

    let singleRequest = request.requests.map((req) => {
      const requestFilter = req.harcirah.filter(
        harcirah => harcirah._id === match.params.id);

      return requestFilter.length > 0 ? requestFilter[0] : null;
    }).filter(req => req !== null);

    if (singleRequest.length > 0) {
      singleRequest = singleRequest[0];

      await this.changeRequest({ ...this.state.request, ...singleRequest });

      this.setState({
        requestType: singleRequest.type,
      });
    } else {
      await getRequest(this.props.match.params.id).then(async (result) => {
        this.setState({
          requestType: result.data.harcirahData.type
        });

        await this.changeRequest(
          { ...this.state.request, ...result.data.harcirahData });
      }).catch(() => {
        history.push('/');
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {i18n} = this.props;
    if (prevProps.i18n.language !== i18n.language) {
      moment.locale(i18n.language === 'en' ? 'en' : 'tr');
    }
  }

  async changeRequest(request) {
    const { travelExpense } = this.props;
    const {
      domesticProspectiveDayLimit, domesticRetroactiveDayLimit, abroadProspectiveDayLimit, abroadRetroactiveDayLimit, sundayNotAllowed
    } = travelExpense.configuration;
    const yurtIciIleri = domesticProspectiveDayLimit;
    const yurtIciGeri = domesticRetroactiveDayLimit;
    const yurtDisiIleri = abroadProspectiveDayLimit;
    const yurtDisiGeri = abroadRetroactiveDayLimit;

    request.yurtIciIleri = yurtIciIleri;
    request.yurtIciGeri = yurtIciGeri;
    request.yurtDisiIleri = yurtDisiIleri;
    request.yurtDisiGeri = yurtDisiGeri;


    if (yurtIciIleri > 0) {
      const harcirahIleriyeDonukKontrolVarMi = true; // ileri yurtiçi girebilir

      request.harcirahIleriyeDonukKontrolVarMi = harcirahIleriyeDonukKontrolVarMi;
    }

    request.pazarHarcirahGirilmesinGenel = sundayNotAllowed;

    this.setState({
      request: { ...request, validation: requestValidate(request) }
    });
  }

  hoursFormat(momentDate) {
    if (momentDate && moment.isMoment(momentDate)) {
      let hour = momentDate.hour();
      let minute = momentDate.minute();

      if (hour === 0 || hour <= 9) hour = `0${hour}`;

      if (minute === 0 || minute <= 9) minute = `0${minute}`;

      return `${hour}:${minute}`;
    }

    return null;
  }

  async changeType(type) {
    const { request } = this.state;

    await this.changeRequest({ ...request, type });
  }

  async changeTravelStartHour(momentDate) {
    const { request } = this.state;
    const payload = { ...request, travelStartHour: this.hoursFormat(momentDate) };

    await this.changeRequest(payload);
  }

  async changeTravelEndHour(momentDate) {
    const { request } = this.state;
    const payload = { ...request, travelEndHour: this.hoursFormat(momentDate) };

    await this.changeRequest(payload);
  }

  async changeTravelStartDate(momentDate) {
    if (moment.isMoment(momentDate)) {
      const { request } = this.state;
      const convertToUnixTime = momentDate.unix() * 1000;
      let payload = { ...request, travelStartDate: convertToUnixTime };

      if (this.checkMomentBiggerThanGivenDate(momentDate, request.travelEndDate)) {
        payload = {
          ...request,
          travelEndDate: convertToUnixTime,
          travelStartDate: convertToUnixTime,
        };
      }

      await this.changeRequest(payload);
    }
  }

  checkMomentBiggerThanGivenDate(momentDate, date) {
    const convertToUnixTime = momentDate.unix() * 1000;

    return convertToUnixTime >= date;
  }


  async changeTravelEndDate(momentDate) {
    if (moment.isMoment(momentDate)) {
      const { request } = this.state;
      const convertToUnixTime = momentDate.unix() * 1000;
      let payload = { ...request, travelEndDate: convertToUnixTime };

      if (!this.checkMomentBiggerThanGivenDate(momentDate, request.travelStartDate)) {
        payload = {
          ...request,
          travelStartDate: convertToUnixTime,
          travelEndDate: convertToUnixTime
        };
      }

      await this.changeRequest(payload);
    }
  }

  async changeDescription(e) {
    const { request } = this.state;

    await this.changeRequest({ ...request, description: e.target.value });
  }

  async changeTravelReasons(val) {
    const { request } = this.state;

    const payload = { ...request, travelReasons: val };

    await this.changeRequest(payload);

    const checkDayCount = payload.travelReasons.some(r => r.value === '7' || r.value === '5');

    this.setState({ checkDayCount });
  }

  async changeIndividualAccommodation(value) {
    const { request } = this.state;
    const payload = {
      ...request,
      individualAccommodation: value,
      individualAccommodationDays: (value ? request.individualAccommodationDays : 0)
    };

    await this.changeRequest(payload);
  }

  async repeatSendToManagersApproval() {
    const { request } = this.state;

    if (!request.validation.valid) {
      Alert.error('HATA', request.validation.message);
    } else {
      await this.props.updateRequest(request);
      await this.props.history.push('/requests');
    }
  }


  async changeIndividualAccommodationDays(e) {
    const { request } = this.state;
    const payload = {
      ...request,
      individualAccommodationDays: e.target.value > 0 ? e.target.value : 0
    };

    await this.changeRequest(payload);
  }


  render() {
    const { request } = this.state;
    const { travelExpense } = this.props;

    console.log(this.props);

    return (
      <div className="row">
        <div className="card">
          <div className="header">
            <div style={{ float: 'left' }}>
              <h4 className="title" style={{ display: 'inline-block' }}>
                {moment(new Date(request.createdDate))
                  .format('DD-MM-YYYY HH:mm')}
              </h4>
              {
                                request.validation
                                  ? (
                                    <small
                                      className="text-info"
                                      style={{ font: '15px Helvetica', marginLeft: '15px' }}
                                    >
                                      {' '}
                                      {request.validation.message}
                                    </small>
                                  )
                                  : null
                            }
            </div>
            <br />
          </div>
          <div className="content">
            <div>
              <br />
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      <span className="required-field">
*
                      </span>
                      {' '} {i18n.t("travelStartDate")}
                    </label>
                    <Datetime
                      key={this.props.i18n.language}
                      locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                      value={request.travelStartDate}
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      onChange={this.changeTravelStartDate}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      <span className="required-field">
*
                      </span>
                      {' '}
                      {i18n.t("travelStartTime")}
                    </label>
                    <Datetime
                      key={this.props.i18n.language}
                      locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                      value={request.travelStartHour}
                      dateFormat={false}
                      timeFormat="HH:mm"
                      onChange={this.changeTravelStartHour}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      <span className="required-field">
*
                      </span>
                      {' '}
                      {i18n.t("travelEndDate")}
                    </label>
                    <Datetime
                      key={this.props.i18n.language}
                      locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                      value={request.travelEndDate}
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      onChange={this.changeTravelEndDate}
                      onBlur={this.travelExpenseInputOnBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      <span className="required-field">
*
                      </span>
                      {' '}
                      {i18n.t("travelEndTime")}
                    </label>
                    <Datetime
                      key={this.props.i18n.language}
                      locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                      value={request.travelEndHour}
                      dateFormat={false}
                      timeFormat="HH:mm"
                      onChange={this.changeTravelEndHour}
                      onBlur={this.travelExpenseInputOnBlur}
                    />
                  </div>
                </div>
              </div>
              <hr />
              <ButtonGroup key="domestic-abroad" justified>
                <Button
                  href="#"
                  bsClass="btn btn-success"
                  active={request.type === DOMESTIC}
                  onClick={() => this.changeType(DOMESTIC)}
                  id='domesticButton'
                >
                  {i18n.t("domestic")}
                </Button>
                <Button
                  href="#"
                  bsClass="btn btn-success"
                  active={request.type === ABROAD}
                  onClick={() => this.changeType(ABROAD)}
                  id='abroadButton'
                >
                  {i18n.t("overseas")}
                </Button>
              </ButtonGroup>
              <br />
              {request.type === DOMESTIC
                ? (
                  <DomesticArea
                    key="edit-domestic"
                    request={request}
                    changeRequest={this.changeRequest}
                  />
                )
                : (
                  <AbroadArea
                    key="edit-abroad"
                    countries={travelExpense.countries}
                    hoursFormat={this.hoursFormat}
                    request={request}
                    changeRequest={this.changeRequest}
                  />
                )}
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      {i18n.t("reasonForTravel")}
                    </label>
                    <Select
                      multi
                      placeholder="Seçiniz"
                      options={this.props.i18n.language === 'tr' ? trTravelReasons : enTravelReasons }
                      value={request.travelReasons}
                      onChange={this.changeTravelReasons}
                      id='travelReason'
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      {i18n.t("explanation")}
                    </label>
                    <textarea
                      rows={5}
                      className="form-control border-input"
                      value={request.description}
                      onChange={this.changeDescription}
                      placeholder="Bu konu hakkında bir açıklama yazabilirsiniz"
                      id='explanation'
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {i18n.t("isThereAccommodation")}
                    </label>
                    <ButtonGroup key="individual-accommodation" justified>
                      <Button
                        href="#"
                        bsClass="btn btn-success"
                        active={!request.individualAccommodation}
                        onClick={() => this.changeIndividualAccommodation(false)}
                        id='noIndividualAccommodation'
                      >
                        {i18n.t("no")}
                      </Button>
                      <Button
                        href="#"
                        bsClass="btn btn-success"
                        active={request.individualAccommodation}
                        disabled={this.state.checkDayCount}
                        onClick={() => this.changeIndividualAccommodation(true)}
                        id='thereIsIndividualAccommodation'
                      >
                        {i18n.t("yes")}
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {i18n.t("howManyDaysAccommodation")}
                    </label>
                    <input
                      type="number"
                      className="form-control border-input"
                      placeholder="Gün sayısı giriniz"
                      value={this.state.checkDayCount ? 0 : request.individualAccommodationDays}
                      onChange={this.changeIndividualAccommodationDays}
                      disabled={!request.individualAccommodation || this.state.checkDayCount}
                      id='howManyDaysStay'
                    />
                  </div>
                </div>
              </div>
              {
                                parseInt(
                                  request.calculatedAmount && request.calculatedAmount.individualAccommodationAmount) > 0
                                  ? (
                                    <div style={{ textAlign: 'center' }}>
                                      <span className="text-success" id='payment'>
                                        <b>
                                          {request.calculatedAmount.individualAccommodationAmount}
                                          {' '}
                                          {getCurrencySymbol(
                                            request.calculatedAmount.abroadCurrency)}
                                        </b>
                                        {' '}
                                        {i18n.t("youWillNetIndividualAccommodation")}
                                        <br />
                                        <br />
                                      </span>
                                    </div>
                                  )
                                  : null
                            }
              <div className="clearfix" />
            </div>
            <div>
              <div className="text-center">
                <p>
                  <small className="text-success">
                    <i className="fa fa-check" />
                    {i18n.t("confirmMessage")}
                  </small>
                </p>
              </div>
              <button
                className="btn btn-success btn-fill btn-block btn-lg"
                onClick={this.repeatSendToManagersApproval}
              >
                {i18n.t("submitAgainForManagerApproval")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  request: state.request,
  travelExpense: state.travelExpense,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...requestActionCreators,
  ...travelExpenseActionsCreators
},
dispatch);

export default withNamespaces()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditRequest)));



// WEBPACK FOOTER //
// ./src/pages/travel-expense/edit/index.js